











































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'
import { dataStore } from '@/utils/store-accessor'

export interface CollectionDetailTabOtherItem {
  workMemo: string
  workMemoTime: string // 日付
  workMemoPlaceCode: SystemCode
  displayMemo: string
  displayMemoTime: string // 日付
  displayMemoPlaceCode: SystemCode
  localMemo: string
  localMemoTime: string // 日付
  localMemoPlaceCode: SystemCode
  checkedDate: string // 日付
  unknownCount: number
  publishDate: string // 日付
  icTagUid: string
}

export const defaultCollectionDetailTabOtherItem = (): CollectionDetailTabOtherItem => ({
  workMemo: '',
  workMemoTime: '', // 日付
  workMemoPlaceCode: defaultSystemCode(),
  displayMemo: '',
  displayMemoTime: '', // 日付
  displayMemoPlaceCode: defaultSystemCode(),
  localMemo: '',
  localMemoTime: '', // 日付
  localMemoPlaceCode: defaultSystemCode(),
  checkedDate: '',
  unknownCount: 0,
  publishDate: '', // 日付
  icTagUid: ''
})

@Component({
  components: {}
})
export default class CollectionDetailTabOther extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: CollectionDetailTabOtherItem

  @Prop({
    type: Boolean,
    default: false
  })
  isOrder!: boolean

  get isCollection(): boolean {
    return !this.isOrder
  }

  get unknownCount(): string {
    return this.isCollection ? String(this.item.unknownCount) : ''
  }

  get enabledIcTagUid(): boolean {
    return dataStore.enabledIcTagUid
  }
}
